function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import { Checkbox } from "@xo-union/tk-component-switches";
import { compose } from "@xo-union/react-css-modules";
import { Subhead, Body1, Body2 } from "@xo-union/tk-ui-typography";
import styles from "./styles.css";
import PropTypes from "prop-types";
var PriceRangeSelector = function PriceRangeSelector(_ref) {
  var step = _ref.step,
    select = _ref.select;
  var options = step.options;
  var handleChange = function handleChange(option) {
    select(option);
  };
  var formatValue = function formatValue(value) {
    if (value === undefined) {
      return "ANY";
    }
    return _typeof(value) == Array ? value.join(",") : value;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.priceRangeSelectorContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.checkboxContainer
  }, _mapInstanceProperty(options).call(options, function (option) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      onChange: function onChange() {
        return handleChange(option);
      },
      classes: !option.enabled ? compose({
        checkmark: styles.checkmark
      }) : compose({
        checkmark: ""
      }),
      key: option.label,
      value: formatValue(option.value),
      disabled: !option.enabled,
      checked: option.selected,
      "data-testid": "checkbox-".concat(option.label)
    }, /*#__PURE__*/React.createElement(Body1, {
      className: !option.enabled ? styles.labelTextDisabled : styles.labelText
    }, option.label, option.count !== undefined && /*#__PURE__*/React.createElement(Body2, {
      className: !option.enabled ? styles.labelTextDisabled : styles.labelCount
    }, "\xA0(", option.count, ")")));
  })));
};
process.env.NODE_ENV !== "production" ? PriceRangeSelector.propTypes = {
  step: PropTypes.shape({
    heading: PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired
    }).isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      enabled: PropTypes.bool.isRequired,
      selected: PropTypes.bool.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number
    })).isRequired
  }).isRequired,
  select: PropTypes.func.isRequired
} : void 0;
export default PriceRangeSelector;